<!-- 图标 -->
<template>
  <div :class="size">
    <img v-if="pattern === 'color'" src="../assets/toplogo.png" />
    <img v-else src="../assets/bottomlogo.png" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    pattern: String,
    size: String,
  },
  name: "CompanyIcon",
});
</script>

<style scoped lang="scss">
.normal {
  width: 40px;
  height: 40px;
}
.irregular {
  width: 46px;
  height: 44px;
}
img {
  width: 100%;
  height: 100%;
}
</style>
